import { FeatherFileText, FeatherTarget } from '@subframe/core';
import { DocTituloSecao } from '@/shared/components/documentos/paginado';

function textoCitacaoPadrao(numeroProcesso: string): string {
  return `Este certificado reúne todas as provas e registros de comunicação do processo arbitral nº ${numeroProcesso}. Ele comprova os envios, entregas e acessos ligados à citação da parte requerida.`;
}

interface SecaoOQueEDocumentoProps {
  numeroProcesso: string;
  texto?: string;
}

export function SecaoOQueEDocumento({ numeroProcesso, texto }: SecaoOQueEDocumentoProps) {
  return (
    <div className="px-[37px] pt-2 pb-[30px]">
      <DocTituloSecao icon={<FeatherFileText className="h-4 w-4" />}>
        O que é este documento?
      </DocTituloSecao>
      <p className="m-0 text-[14px] leading-[1.6] text-neutral-700">
        {texto ?? textoCitacaoPadrao(numeroProcesso)}
      </p>
    </div>
  );
}

interface SecaoObjetivoProps {
  paragrafos: string[];
  titulo?: string;
}

export function SecaoObjetivo({
  paragrafos,
  titulo = 'Qual é o objetivo da notificação?',
}: SecaoObjetivoProps) {
  return (
    <div className="px-[37px] pb-6">
      <DocTituloSecao icon={<FeatherTarget className="h-4 w-4" />}>{titulo}</DocTituloSecao>
      {paragrafos.map((paragrafo) => (
        <p key={paragrafo} className="mb-[10px] text-[14px] leading-[1.6] text-neutral-700">
          {paragrafo}
        </p>
      ))}
    </div>
  );
}
